import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import {
  FcaRegisterFirmDetails,
  FcaRegisterHeaderActions,
  FcaRegisterNames,
  FcaRegisterNotConnected,
  FcaRegisterNotice,
  FcaRegisterPeople,
  FcaRegisterRegulation,
} from "@/features/sources/components/fca-register-sections"
import { fcaRegisterQueries } from "@/queries/fca-register"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      fcaRegisterQueries.forFirm(params.firmId)
    ),
  component: FirmFcaRegisterPage,
})

function FirmFcaRegisterPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="FCA Register"
        actions={<FcaRegisterHeaderActions firmId={firmId} />}
      />
      <PageContent>
        <FcaRegisterNotConnected firmId={firmId} />
        <FcaRegisterNotice firmId={firmId} />
        <FcaRegisterFirmDetails firmId={firmId} />
        <FcaRegisterNames firmId={firmId} />
        <FcaRegisterPeople firmId={firmId} />
        <FcaRegisterRegulation firmId={firmId} />
      </PageContent>
    </>
  )
}
